
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as _91id_93PPW2A3BioeJzkQG4StrtuA42OBCZfK4lPS6hd5zdFZEMeta } from "/app/app/pages/client/v2/portfolio-sharing/start/[id].vue?macro=true";
import { default as _91id_930aiu29njrJWAnxQFXk8jgeY8ka71K8HLKYSamvBJq_oMeta } from "/app/app/pages/client/v2/portfolio-sharing/step-1/[id].vue?macro=true";
import { default as _91id_93ePh3uFJO6GH0JnJ4L8ATRT8ZVvxFqOPlKq58deH_AmAMeta } from "/app/app/pages/client/v2/portfolio-sharing/step-2/[id].vue?macro=true";
import { default as _91id_936R7tBSvl6_16l3RlhySzWs7RMC0VqP4uXudKQu464zUMeta } from "/app/app/pages/client/portfolio-sharing/start/[id].vue?macro=true";
import { default as _91id_93M4Qtr3AHHNSRZPIg8fT_4h2poGHA2DAYsii4Va_qXf0Meta } from "/app/app/pages/client/portfolio-sharing/step-1/[id].vue?macro=true";
import { default as _91id_93sOvtyw7Fgd7CxlAeQ18SiwZBCCrvhtPzAdII3rk6cS0Meta } from "/app/app/pages/client/portfolio-sharing/step-2/[id].vue?macro=true";
import { default as _91id_932DE5ph_ekWuMs_JJc1ExIced81eAPKQ2kcj2Hhp58w4Meta } from "/app/app/pages/client/v2/portfolio-report/[id].vue?macro=true";
import { default as newu_rQHlN6A35Op4d1aIOSUAEhwbdsyfT50m9tUIDUTOEMeta } from "/app/app/pages/advisor/clients/new.vue?macro=true";
import { default as report_45doneH1PpxdKXyq1bvnwDYgYzJyvVwY3lEHOctHwnzAidrWAMeta } from "/app/app/pages/client/v2/report-done.vue?macro=true";
import { default as start_45holdings_45collectionrNX9r_xy3yIDfB7Iw8jx4XDUPBKq6lx7NurvqiwHSZkMeta } from "/app/app/pages/client/v2/start-holdings-collection.vue?macro=true";
import { default as _91position_id_93wLUtv1laogZKT0ZUtUqJvY31yxeGXXmU6l61BCScZdUMeta } from "/app/app/pages/advisor/clients/[client_id]/account/[account_id]/position/[position_id].vue?macro=true";
import { default as indexmer6aAq1RsmpGbiH_eywoSOwne8Gr0OaPRQEhafwT8kMeta } from "/app/app/pages/advisor/clients/[client_id]/account/[account_id]/index.vue?macro=true";
import { default as _91report_id_93pZm_cMvzuUzi1olHt8ZO0_VcyDeIVBgz2ja0syFiZwkMeta } from "/app/app/pages/advisor/clients/[client_id]/report/[report_id].vue?macro=true";
import { default as editTHW2yElG09n5IX_fef8XJN_2j7bpOyWhj8dghWgDpWUMeta } from "/app/app/pages/advisor/clients/[client_id]/edit.vue?macro=true";
import { default as indexHgX1h4StnbIpVIy5PVvgxod1JNsmmP9PqmIRYb9zuRsMeta } from "/app/app/pages/advisor/clients/[client_id]/index.vue?macro=true";
import { default as _91id_9393mPEucArGEcWi7d8wWPGKCUVmhrSqlPr7JKg8PpPBMMeta } from "/app/app/pages/client/portfolio-report/[id].vue?macro=true";
import { default as indexAo4_QMhJ4OxaIgCEvjplq66iaS4bNnHQaKMO5Tw2GEEMeta } from "/app/app/pages/advisor/clients/index.vue?macro=true";
import { default as report_45donesrgC3XVuZt_QDoENg3ZBwhXfgHxyLA39JvowNmGFQlYMeta } from "/app/app/pages/client/report-done.vue?macro=true";
import { default as start_45holdings_45collectiondmJ_bOvqUdYanQhKuCFxe4RFJ_FMUpGwQhD4_rQnsScMeta } from "/app/app/pages/client/start-holdings-collection.vue?macro=true";
import { default as terms_45and_45conditionsJKGuUZsa2sxwVgko68P82LOlS8KbYeUkkO9ydvaSWDQMeta } from "/app/app/pages/client/terms-and-conditions.vue?macro=true";
import { default as njorda_45adminfDXpOmRlsdYWLmnZW5OaLQmrS7R35DRxz_iCQJP2D3kMeta } from "/app/app/pages/login/njorda-admin.vue?macro=true";
import { default as confirm_45subscription2aOS8R8U2yzwXRNfoF1UKPaY_eVVB9wsXEv6Dll9OX4Meta } from "/app/app/pages/onboarding/confirm-subscription.vue?macro=true";
import { default as organization_45verification7Gtdf7UQBn2imzXC_PNZW3xBNNtTQKcoXFjHcOf8EMIMeta } from "/app/app/pages/onboarding/organization-verification.vue?macro=true";
import { default as registerTehVPZrVzisVJ926lCc0O6s3h3z94Grw95OZ8_kKKCcMeta } from "/app/app/pages/onboarding/register.vue?macro=true";
import { default as select_45subscriptionq07695ntv4JoUV2dmlozgz7UzGmKRnI4ee0CjUjg8rAMeta } from "/app/app/pages/onboarding/select-subscription.vue?macro=true";
import { default as select16mCNo1fXENTOL8Z89Lkebo4_DbkJ_Gnep3DHLLl_bAMeta } from "/app/app/pages/subscription/select.vue?macro=true";
import { default as indexSl1DH_1AdS0aIIKUoEisD4HvJ_gN1iXGfjJ_Q8FcJvQMeta } from "/app/app/pages/advisor/index.vue?macro=true";
import { default as indexvDRB_mS77Lq67fCzrkoeErAso0Vf340a6nARd7o2AagMeta } from "/app/app/pages/login/index.vue?macro=true";
import { default as logout2OMJkScAmUDOL6_uAnnKkIkqlwTKTGCfC_SvfMsXjp4Meta } from "/app/app/pages/logout.vue?macro=true";
import { default as test_45linksWotDeDZ3WmNPxBvzy_Vu7mSjPsKI2e3o8CL6S6Ht0EMMeta } from "/app/app/pages/test-links.vue?macro=true";
import { default as index4nVS2Dd4a5t9zrU2j8coCxsqtPYupm_GEv_2EzeGhJUMeta } from "/app/app/pages/index.vue?macro=true";
export default [
  {
    name: "client-v2-portfolio-sharing-start-id",
    path: "/client/v2/portfolio-sharing/start/:id()",
    meta: { ...(_91id_93PPW2A3BioeJzkQG4StrtuA42OBCZfK4lPS6hd5zdFZEMeta || {}), ...{"middleware":["access-required","subscription-required"]} },
    component: () => import("/app/app/pages/client/v2/portfolio-sharing/start/[id].vue")
  },
  {
    name: "client-v2-portfolio-sharing-step-1-id",
    path: "/client/v2/portfolio-sharing/step-1/:id()",
    meta: { ...(_91id_930aiu29njrJWAnxQFXk8jgeY8ka71K8HLKYSamvBJq_oMeta || {}), ...{"middleware":["access-required","subscription-required"]} },
    component: () => import("/app/app/pages/client/v2/portfolio-sharing/step-1/[id].vue")
  },
  {
    name: "client-v2-portfolio-sharing-step-2-id",
    path: "/client/v2/portfolio-sharing/step-2/:id()",
    meta: { ...(_91id_93ePh3uFJO6GH0JnJ4L8ATRT8ZVvxFqOPlKq58deH_AmAMeta || {}), ...{"middleware":["access-required","subscription-required"]} },
    component: () => import("/app/app/pages/client/v2/portfolio-sharing/step-2/[id].vue")
  },
  {
    name: "client-portfolio-sharing-start-id",
    path: "/client/portfolio-sharing/start/:id()",
    meta: _91id_936R7tBSvl6_16l3RlhySzWs7RMC0VqP4uXudKQu464zUMeta || {},
    component: () => import("/app/app/pages/client/portfolio-sharing/start/[id].vue")
  },
  {
    name: "client-portfolio-sharing-step-1-id",
    path: "/client/portfolio-sharing/step-1/:id()",
    meta: _91id_93M4Qtr3AHHNSRZPIg8fT_4h2poGHA2DAYsii4Va_qXf0Meta || {},
    component: () => import("/app/app/pages/client/portfolio-sharing/step-1/[id].vue")
  },
  {
    name: "client-portfolio-sharing-step-2-id",
    path: "/client/portfolio-sharing/step-2/:id()",
    meta: _91id_93sOvtyw7Fgd7CxlAeQ18SiwZBCCrvhtPzAdII3rk6cS0Meta || {},
    component: () => import("/app/app/pages/client/portfolio-sharing/step-2/[id].vue")
  },
  {
    name: "client-v2-portfolio-report-id",
    path: "/client/v2/portfolio-report/:id()",
    meta: { ...(_91id_932DE5ph_ekWuMs_JJc1ExIced81eAPKQ2kcj2Hhp58w4Meta || {}), ...{"middleware":["access-required","subscription-required"]} },
    component: () => import("/app/app/pages/client/v2/portfolio-report/[id].vue")
  },
  {
    name: "advisor-clients-new",
    path: "/advisor/clients/new",
    meta: { ...(newu_rQHlN6A35Op4d1aIOSUAEhwbdsyfT50m9tUIDUTOEMeta || {}), ...{"middleware":["access-required","subscription-required"]} },
    component: () => import("/app/app/pages/advisor/clients/new.vue")
  },
  {
    name: "client-v2-report-done",
    path: "/client/v2/report-done",
    meta: { ...(report_45doneH1PpxdKXyq1bvnwDYgYzJyvVwY3lEHOctHwnzAidrWAMeta || {}), ...{"middleware":["access-required","subscription-required"]} },
    component: () => import("/app/app/pages/client/v2/report-done.vue")
  },
  {
    name: "client-v2-start-holdings-collection",
    path: "/client/v2/start-holdings-collection",
    meta: { ...(start_45holdings_45collectionrNX9r_xy3yIDfB7Iw8jx4XDUPBKq6lx7NurvqiwHSZkMeta || {}), ...{"middleware":["access-required","subscription-required"]} },
    component: () => import("/app/app/pages/client/v2/start-holdings-collection.vue")
  },
  {
    name: "advisor-clients-client_id-account-account_id-position-position_id",
    path: "/advisor/clients/:client_id()/account/:account_id()/position/:position_id()",
    meta: { ...(_91position_id_93wLUtv1laogZKT0ZUtUqJvY31yxeGXXmU6l61BCScZdUMeta || {}), ...{"middleware":["access-required","subscription-required"]} },
    component: () => import("/app/app/pages/advisor/clients/[client_id]/account/[account_id]/position/[position_id].vue")
  },
  {
    name: "advisor-clients-client_id-account-account_id",
    path: "/advisor/clients/:client_id()/account/:account_id()",
    meta: { ...(indexmer6aAq1RsmpGbiH_eywoSOwne8Gr0OaPRQEhafwT8kMeta || {}), ...{"middleware":["access-required","subscription-required"]} },
    component: () => import("/app/app/pages/advisor/clients/[client_id]/account/[account_id]/index.vue")
  },
  {
    name: "advisor-clients-client_id-report-report_id",
    path: "/advisor/clients/:client_id()/report/:report_id()",
    meta: { ...(_91report_id_93pZm_cMvzuUzi1olHt8ZO0_VcyDeIVBgz2ja0syFiZwkMeta || {}), ...{"middleware":["access-required","subscription-required"]} },
    component: () => import("/app/app/pages/advisor/clients/[client_id]/report/[report_id].vue")
  },
  {
    name: "advisor-clients-client_id-edit",
    path: "/advisor/clients/:client_id()/edit",
    meta: { ...(editTHW2yElG09n5IX_fef8XJN_2j7bpOyWhj8dghWgDpWUMeta || {}), ...{"middleware":["access-required","subscription-required"]} },
    component: () => import("/app/app/pages/advisor/clients/[client_id]/edit.vue")
  },
  {
    name: "advisor-clients-client_id",
    path: "/advisor/clients/:client_id()",
    meta: { ...(indexHgX1h4StnbIpVIy5PVvgxod1JNsmmP9PqmIRYb9zuRsMeta || {}), ...{"middleware":["access-required","subscription-required"]} },
    component: () => import("/app/app/pages/advisor/clients/[client_id]/index.vue")
  },
  {
    name: "client-portfolio-report-id",
    path: "/client/portfolio-report/:id()",
    meta: _91id_9393mPEucArGEcWi7d8wWPGKCUVmhrSqlPr7JKg8PpPBMMeta || {},
    component: () => import("/app/app/pages/client/portfolio-report/[id].vue")
  },
  {
    name: "advisor-clients",
    path: "/advisor/clients",
    meta: { ...(indexAo4_QMhJ4OxaIgCEvjplq66iaS4bNnHQaKMO5Tw2GEEMeta || {}), ...{"middleware":["access-required","subscription-required"]} },
    component: () => import("/app/app/pages/advisor/clients/index.vue")
  },
  {
    name: "client-report-done",
    path: "/client/report-done",
    meta: report_45donesrgC3XVuZt_QDoENg3ZBwhXfgHxyLA39JvowNmGFQlYMeta || {},
    component: () => import("/app/app/pages/client/report-done.vue")
  },
  {
    name: "client-start-holdings-collection",
    path: "/client/start-holdings-collection",
    meta: start_45holdings_45collectiondmJ_bOvqUdYanQhKuCFxe4RFJ_FMUpGwQhD4_rQnsScMeta || {},
    component: () => import("/app/app/pages/client/start-holdings-collection.vue")
  },
  {
    name: "client-terms-and-conditions",
    path: "/client/terms-and-conditions",
    meta: terms_45and_45conditionsJKGuUZsa2sxwVgko68P82LOlS8KbYeUkkO9ydvaSWDQMeta || {},
    component: () => import("/app/app/pages/client/terms-and-conditions.vue")
  },
  {
    name: "login-njorda-admin",
    path: "/login/njorda-admin",
    meta: njorda_45adminfDXpOmRlsdYWLmnZW5OaLQmrS7R35DRxz_iCQJP2D3kMeta || {},
    component: () => import("/app/app/pages/login/njorda-admin.vue")
  },
  {
    name: "onboarding-confirm-subscription",
    path: "/onboarding/confirm-subscription",
    meta: { ...(confirm_45subscription2aOS8R8U2yzwXRNfoF1UKPaY_eVVB9wsXEv6Dll9OX4Meta || {}), ...{"middleware":"access-required"} },
    component: () => import("/app/app/pages/onboarding/confirm-subscription.vue")
  },
  {
    name: "onboarding-organization-verification",
    path: "/onboarding/organization-verification",
    meta: organization_45verification7Gtdf7UQBn2imzXC_PNZW3xBNNtTQKcoXFjHcOf8EMIMeta || {},
    component: () => import("/app/app/pages/onboarding/organization-verification.vue")
  },
  {
    name: "onboarding-register",
    path: "/onboarding/register",
    meta: registerTehVPZrVzisVJ926lCc0O6s3h3z94Grw95OZ8_kKKCcMeta || {},
    component: () => import("/app/app/pages/onboarding/register.vue")
  },
  {
    name: "onboarding-select-subscription",
    path: "/onboarding/select-subscription",
    meta: { ...(select_45subscriptionq07695ntv4JoUV2dmlozgz7UzGmKRnI4ee0CjUjg8rAMeta || {}), ...{"middleware":"access-required"} },
    component: () => import("/app/app/pages/onboarding/select-subscription.vue")
  },
  {
    name: "subscription-select",
    path: "/subscription/select",
    meta: { ...(select16mCNo1fXENTOL8Z89Lkebo4_DbkJ_Gnep3DHLLl_bAMeta || {}), ...{"middleware":"access-required"} },
    component: () => import("/app/app/pages/subscription/select.vue")
  },
  {
    name: "advisor",
    path: "/advisor",
    meta: { ...(indexSl1DH_1AdS0aIIKUoEisD4HvJ_gN1iXGfjJ_Q8FcJvQMeta || {}), ...{"middleware":["access-required","subscription-required"]} },
    component: () => import("/app/app/pages/advisor/index.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: indexvDRB_mS77Lq67fCzrkoeErAso0Vf340a6nARd7o2AagMeta || {},
    component: () => import("/app/app/pages/login/index.vue")
  },
  {
    name: "logout",
    path: "/logout",
    meta: logout2OMJkScAmUDOL6_uAnnKkIkqlwTKTGCfC_SvfMsXjp4Meta || {},
    component: () => import("/app/app/pages/logout.vue")
  },
  {
    name: "test-links",
    path: "/test-links",
    meta: test_45linksWotDeDZ3WmNPxBvzy_Vu7mSjPsKI2e3o8CL6S6Ht0EMMeta || {},
    component: () => import("/app/app/pages/test-links.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/app/app/pages/index.vue")
  }
]